import { render, staticRenderFns } from "./editOrganization.vue?vue&type=template&id=160c9fb5&"
import script from "./editOrganization.vue?vue&type=script&lang=ts&"
export * from "./editOrganization.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "editOrganization.vue"
export default component.exports